import LocalizedLink from '../LocalizedLink';

const variants = {
  primary: 'bg-blue-600 text-white shadow-lg hover:bg-blue-700 hover:shadow-xl',
};

const sizes = {
  lg: 'px-12 py-5 text-xl',
  md: 'px-10 py-4 text-lg',
};

const LocalizedButton = ({ to, name, variant = 'primary', size = 'lg' }) => {
  return (
    <LocalizedLink
      to={to}
      className={`inline-block w-fit rounded-lg font-semibold transition-colors ${variants[variant]} ${sizes[size]}`}
    >
      {name}
    </LocalizedLink>
  );
};

export default LocalizedButton;
